import { ref } from 'vue'
import { defineStore } from 'pinia'
import { setUrlParam } from '@/utils'
import type { BundleSize, BundlePricing } from '@/types'

export interface SpecialDiscount {
  code: string
  percentage: number
  name: string
  minPurchase: number
  description: string
  pricing: Record<number, Pick<BundlePricing, 'firstOrderCents' | 'firstOrderDiscountPercent'>>
  allowedSizes?: BundleSize[] // optional, if not provided, all sizes are allowed
  expiresAt?: number // optional, if not provided, the discount never expires
}

const SPECIAL_DISCOUNTS: Record<string, SpecialDiscount> = {
  NEWYEARREACTIVATION: {
    code: 'NEWYEARREACTIVATION',
    percentage: 40,
    name: 'Special Discount',
    minPurchase: 5800,
    description: '40% off your subscription order!',
    // allowedSizes: [ 16, 24, 32 ],
    expiresAt: (new Date('2026-01-21 23:59:59-07:00').getTime() - new Date().getTime()),
    pricing: {
      16: {
        firstOrderCents: 3600,
        firstOrderDiscountPercent: 40
      },
      24: {
        firstOrderCents: 5040,
        firstOrderDiscountPercent: 40
      },
      32: {
        firstOrderCents: 6360,
        firstOrderDiscountPercent: 40
      }
    }
  }
}

export const useSpecialDiscountStore = defineStore('special-discount', () => {

  // const bundleStore = useBundleStore()

  const discountCode = ref<string>()
  const activeDiscount = ref<SpecialDiscount>()
  const toastsShown = ref<string[]>([])

  // const qualifiesForDiscount = computed(() => {
  //   if (!activeDiscount.value) return false

  //   const discount = activeDiscount.value

  //   if (!discount.allowedSizes?.includes(bundleStore.size)) {
  //     return false
  //   }

  //   if (bundleStore.priceCents < discount.minPurchase) {
  //     return false
  //   }

  //   return true
  // })

  // const hasActiveDiscount = computed(() => {
  //   return activeDiscount.value !== null && qualifiesForDiscount.value
  // })

  // const hasDiscountCodeButNotQualified = computed(() => {
  //   return activeDiscount.value !== null && !qualifiesForDiscount.value
  // })

  // const disqualificationReason = computed(() => {
  //   if (!activeDiscount.value || qualifiesForDiscount.value) return null

  //   const discount = activeDiscount.value
  //   const sizes = discount.allowedSizes

  //   if (sizes && !sizes?.includes(bundleStore.size)) {
  //     return `This discount is only valid for ${sizes.join(' or ')}-pack bundles`
  //   }

  //   if (bundleStore.priceCents < discount.minPurchase) {
  //     return `Minimum purchase of $${(discount.minPurchase / 100).toFixed(2)} required`
  //   }

  //   return null
  // })

  const hasShownToast = (code: string) => {
    return toastsShown.value.includes(code)
  }

  const init = () => {
    const discountParam = new URLSearchParams(window.location.search).get('discount')

    // get discount code from url, or use persisted code from store if no url param
    const code = String(discountParam || discountCode.value || '').toUpperCase()
    const specialDiscount = SPECIAL_DISCOUNTS[code]

    if (!code.length || !specialDiscount) {
      // no discount code or invalid discount code
      return
    }

    // clear expired discounts and do not activate
    if (specialDiscount.expiresAt !== undefined && specialDiscount.expiresAt <= 0) {
      discountCode.value = undefined
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { special_discount: '' } })
      })
      return
    }

    discountCode.value = code
    activeDiscount.value = specialDiscount

    setUrlParam('discount', undefined)
  }

  return {
    activeDiscount,
    toastsShown,
    // hasActiveDiscount,
    // qualifiesForDiscount,
    // hasDiscountCodeButNotQualified,
    // disqualificationReason,
    discountCode,
    hasShownToast,
    init
  }
}, {
  persist: {
    storage: window.sessionStorage,
    pick: [ 'discountCode', 'toastsShown' ],
    afterHydrate: ({ store }) => {
      store.init()
      store.$persist()
    }
  }
})
